<template>
  <v-row>
    <v-col cols="12" sm="10" md="10" lg="8" class="px-md-11 mx-auto">
      <v-card :height="$vuetify.breakpoint.mdAndUp ? 654 : ''" rounded="lg">
        <v-container fluid fill-height>
          <v-row>
            <v-col
              cols="5"
              class="pa-0 pr-0 d-none d-md-flex cabin-truck-image-wrapper"
            >
              <div class="cabin-truck-image"></div>
            </v-col>
            <v-col
              class="col-12 col-md-7 py-11 py-md-14 py-lg-9 py-xl-14 px-11 px-xl-16"
            >
              <div class="d-flex flex-column text-center card-container">
                <h1
                  class="secondary--text font-weight-black d-flex mx-auto text-xs-h4"
                >
                  {{
                    $t('portal.register.set_password_succesfull.labels.title')
                  }}
                </h1>
                <p
                  class="secondary--text d-flex mx-auto mb-0 font-weight-normal text-h6"
                >
                  {{
                    $t(
                      'portal.register.set_password_succesfull.labels.label_register'
                    )
                  }}
                </p>

                <v-stepper alt-labels value="2" id="stepper">
                  <v-stepper-header style="box-shadow: none">
                    <v-divider class="divider"></v-divider>
                    <v-stepper-step complete step="1">
                      <p
                        class="text-center light-grey font-weight-black text-h6 mb-0"
                      >
                        {{
                          $t(
                            'portal.register.set_password_succesfull.labels.label_step_one'
                          )
                        }}
                      </p>
                    </v-stepper-step>

                    <v-divider class="divider"></v-divider>

                    <v-stepper-step complete step="2">
                      <p
                        class="text-center primary--text font-weight-black text-h6 mb-0"
                      >
                        {{
                          $t(
                            'portal.register.set_password_succesfull.labels.label_step_two'
                          )
                        }}
                      </p>
                    </v-stepper-step>
                    <v-divider class="divider"></v-divider>
                  </v-stepper-header>
                </v-stepper>
                <div class="mt-8">
                  <h4 class="font-weight-bold text-h6 secondary--text">
                    {{
                      $t(
                        'portal.register.set_password_succesfull.labels.label_finished'
                      )
                    }}
                  </h4>
                  <div class="d-flex flex-wrap justify-center mt-5">
                    <v-btn
                      :href="googlePlayLink"
                      class="app-btn-link mb-4 mb-md-0"
                      text
                      target="_blank"
                    >
                      <GooglePlaySvg />
                    </v-btn>
                    <v-btn class="app-btn-link app-btn-link mb-4 mb-md-5" text :to="{ name: 'login' }">
                      <WebVersionSvg />
                    </v-btn>
                    <v-btn
                      :href="AppleStoreLink"
                      class="app-btn-link mb-4 mb-md-0"
                      style="text-transform: none;"
                      text
                      target="_blank"
                    >
                      <AppleStore />
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import GooglePlaySvg from '@/assets/bot-googleplay.svg'
import WebVersionSvg from '@/assets/bot-version-web.svg'
import AppleStore from '@/assets/bot-applestore.svg'

import { GOOGLE_PLAY_APP_URL , APPLE_STORE_APP_URL } from '@leapsight/styleguide'
export default {
  name: 'set-password-succesfull',
  components: {
    GooglePlaySvg,
    WebVersionSvg,
    AppleStore
  },
  props: {},
  data() {
    return {}
  },
  methods: {},
  computed: {
    googlePlayLink() {
      return GOOGLE_PLAY_APP_URL
    },
    AppleStoreLink() {
      return APPLE_STORE_APP_URL
    }
  },
  watch: {}
  // Lifecycles
}
</script>

<style lang="scss" scoped>
.container.fill-height {
  align-items: initial !important;
}
.cabin-truck-image-wrapper {
  position: relative;
  .cabin-truck-image {
    background-image: url('../../assets/cabin-truck.png');
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    background-position: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
}

.pass-cond {
  color: var(--brownish-grey);
}
.light-grey {
  color: var(--light-grey-blue);
}
.divider {
  background-color: var(--dark-hot-pink);
  height: 3px;
  max-height: 3px;
}

.app-btn-link:hover::before {
  opacity: 0;
}
</style>
